// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"68368c2f","67":"56f9ef9d","128":"b1ce8ee3","267":"cf194dd0","322":"68368c2f","335":"51e01aeb","444":"2ed15103","594":"85794019","864":"cf194dd0","991":"81d52457"}[chunkId] + ".chunk.css";
};